var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkItem2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 4H28C28.7364 4 29.3333 4.59696 29.3333 5.33333V26.6667C29.3333 27.4031 28.7364 28 28 28H20C20 27.0932 19.9304 26.2025 19.7961 25.3333H26.6666V6.66667H5.33329V10.8705C4.46404 10.7363 3.57347 10.6667 2.66663 10.6667V5.33333C2.66663 4.59696 3.26359 4 3.99996 4ZM17.3333 28H14.6666C14.6666 21.3725 9.29404 16 2.66663 16V13.3333C10.7668 13.3333 17.3333 19.8999 17.3333 28ZM12 28H9.33329C9.33329 24.3181 6.34852 21.3333 2.66663 21.3333V18.6667C7.82128 18.6667 12 22.8453 12 28ZM6.66663 28H2.66663V24C4.87576 24 6.66663 25.7908 6.66663 28Z",
    fill: "#26539C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkItem2);
export default __webpack_public_path__ + "static/media/icon_link_item2.f3ef82d72f038256b02440b49be380a6.svg";
export { ForwardRef as ReactComponent };